import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import type { ApiServerEntityIDType } from '../../../types';
import { AttachmentViewModel } from '../../resource/attachment/viewModel';

export class ClientAudioViewModel {
  @Expose()
  @ApiProperty()
  id: ApiServerEntityIDType;

  @Expose()
  @ApiProperty()
  clientId: ApiServerEntityIDType;

  @Expose()
  @ApiProperty()
  attachmentId: ApiServerEntityIDType;

  @Expose()
  @ApiProperty()
  audioUrl: string;

  @Expose()
  @ApiProperty()
  mimeType: string;

  @Expose()
  @ApiProperty()
  fileSize: number;

  @Expose()
  @ApiProperty()
  createdAt: string;

  @Expose()
  @ApiProperty()
  updatedAt: string;

  @Expose()
  @ApiProperty({ type: AttachmentViewModel })
  audio: AttachmentViewModel;
}
